import { isIosWebKit } from "../utils/isIosWebKit";

let started = false;

/**
 * Warm the next platform screens after first paint.
 * One chunk at a time. The legacy match shell stays out of this list — pulling
 * it during startup is enough to jetsam an iPhone tab before the page appears.
 */
export function prefetchRouteChunks() {
  if (started || typeof window === "undefined") return;
  started = true;
  const chunks = [
    () => import("../features/lobby/components/ArenaPage"),
    () => import("../features/lobby/components/DiscoverPage"),
    () => import("../features/tournament/management/CompetitionsDashboardPage"),
  ];
  const run = () => {
    chunks.reduce(
      (chain, load) => chain.then(() => load().catch(() => {})),
      Promise.resolve()
    );
  };
  const delayMs = isIosWebKit() ? 8000 : 2500;
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(run, { timeout: delayMs + 4000 });
  } else {
    window.setTimeout(run, delayMs);
  }
}
